import Vue from 'vue'
import Router from 'vue-router'
import NotFoundComponent from '@/components/NotFoundComponent' // not found

Vue.use(Router)

export default new Router({
  routes: [
    // 涉历史虚无主义有害信息举报专区
    {
      path: '/',
      name: '/report',
      component: resolve => {
        require(['@/views/report/report.vue'], resolve)
      }
    },
    // 有害
    {
      path: '/harm',
      name: '/harm',
      component: resolve => {
        require(['@/views/report/harm.vue'], resolve)
      }
    },
    // 举报提交页面
    {
      path: '/harmSubmit',
      name: '/harmSubmit',
      component: resolve => {
        require(['@/views/report/reportSubmit.vue'], resolve)
      }
    },
    // 举报提交页面
    {
      path: '/reportSubmit',
      name: '/reportSubmit',
      component: resolve => {
        require(['@/views/report/reportSubmit.vue'], resolve)
      }
    },
    // not Found
    {
      path: '*',
      component: NotFoundComponent
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    return {
      x: 0,
      y: 0
    }
  }
})

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}



// WEBPACK FOOTER //
// ./src/router/index.js